import { Controller } from "@hotwired/stimulus"

// Displays a live countdown showing seconds remaining in the current
// TOTP 30-second window. Calculated client-side from Unix timestamp —
// no API call needed since TOTP time steps are deterministic.
export default class extends Controller {
  static targets = ["seconds", "progress"]

  connect() {
    this.update()
    this.timer = setInterval(() => this.update(), 1000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  update() {
    const remaining = 30 - (Math.floor(Date.now() / 1000) % 30)
    this.secondsTarget.textContent = remaining

    if (this.hasProgressTarget) {
      this.progressTarget.style.width = `${(remaining / 30) * 100}%`
    }

    // Visual warning when time is running low (< 6 seconds)
    if (remaining <= 5) {
      this.secondsTarget.classList.add("text-danger", "fw-bold")
    } else {
      this.secondsTarget.classList.remove("text-danger", "fw-bold")
    }
  }
}
